import { createSlice } from "@reduxjs/toolkit";

// const initialState = {
// 	auth: null,
// };

const initialState = {
  auth: {
    accessToken: null,
    refreshToken: null,
    user: null,
    providerToken: null,
    login: false,
  },
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth: (state, { payload }) => {
      state.auth = payload;
    },
    resetAuth: (state) => {
      state.auth = initialState.auth;
    },
  },
});


// export const authSlice = createSlice({
// 	name: "auth",
// 	initialState,
// 	reducers: {
// 		setAuth: (state, {payload}) => {
// 			return { ...state, auth: payload };
// 		},
// 		resetAuth: (state) => {
// 			return { ...state, auth: null };
// 		}
// 	},
// });

export const { setAuth, resetAuth } = authSlice.actions;

export default authSlice.reducer;
